<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents">
      <div class="l-solutionDetail">
        <div class="l-solutionDetail__body">
          <h1 class="l-pageTitle"><span class="l-pageLabel">ソリューション</span>{{ solution.name }}</h1>
          <div class="l-contentsBox">
            <span class="l-contentsTitle__sub" style="margin-bottom: 20px;padding: 0;">掲載日： {{ $dayjs(solution.startDate).format("YYYY/MM/DD") }}</span>
            <div class="l-solutionDetail__box">
              <div class="l-solutionDetail__info">
                <div class="l-solutionDetail__thumbnail"><img :src="thumbNailImageFile" alt="" style="max-width: 100%; height: auto; width /***/:auto;"></div>
                <div class="btn-basic is-blank is-middle"><a :href="solution.introductionPageUrl" target="_blank">紹介ページ</a></div>
                <div class="btn-basic is-blank is-middle"><a :href="solution.contactUrl" target="_blank">お問い合わせ</a></div>
                <div class="l-solutionDetail__download" v-show="documentFile.fileNm">
                  <h3>資料ダウンロード</h3>
                  <a class="l-pdf" @click="download(documentFile.url, documentFile.fileNm)">{{ documentFile.fileNm }}（PDF  {{ documentFile.size }}Mb）</a>
                </div>
              </div>
              <div class="l-solutionDetail__contents">
                <article>
                  <h1>{{ solution.catchCopy }}</h1>
                  <p style="padding-left: 20px; white-space: pre-line;">{{ solution.description }}</p>
                </article>
              </div>
            </div>
          </div>
        </div>

        <!-- ソリューションリスト -->
        <div class="l-solutionDetail__aside">
          <div class="l-contentsTitle is-noicon">
            <h2 class="l-contentsTitle__text">ソリューション</h2>
          </div>
          <ul class="l-solutionSideList">
            <li class="l-solutionSideList__item" v-for="solution in solutionList" :key="solution.solutionId" @click="getSolution(solution.solutionId)">
              <a>
                <p class="l-solutionSideList__title">{{ solution.name }}</p>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import { saveAs } from "file-saver";

export default {
  components: {
    Loading,
  },
  data() {
    return {
      isProcessing: false,
      solution: {
        solutionId: null,
        name: '',
        description: '',
        introductionPageUrl: '',
        contactUrl: '',
        startDate: null
      },
      file: {
        fileNm: '',
        filePath: '',
        url: '',
      },
      documentFile: {
        fileNm: '',
        filePath: '',
        url: '',
        size: 0,
      },
      solutionList: [
        {
          name: ''
        }
      ],
      thumbNailImageFile: '',
    }
  },
  computed: {
    solutionId() {
      return this.$store.getters['solution/getSolutionId'];
    },
  },
  created: function () {
    this.getSolution(this.solutionId);
    this.getSolutionList();
  },
  methods: {
    async getSolution(solutionId) {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/diag/solution/getSolution', {
        solutionId: solutionId
      });
      if (res) {
        this.solution = res.data.solution;
        this.file = res.data.file;
        this.documentFile = res.data.documentFile;
        this.thumbNailImageFile = res.data.thumbNailImageFile;
      }
      this.isProcessing = false;
    },
    async getSolutionList() {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/diag/solution/getSolutionList', {
      });
      if (res) {
        this.solutionList = res.data.solutionList;
      }
      this.isProcessing = false;
    },
    async download() {
      await saveAs('/ld/api/diag/solution/downloadSolutionDocumentFile?id=' + this.solution.solutionId);
    },
  }
}

</script>